var animateInputLabel = function(){
  var inputLabels;
  var textareaLabels;
  
  var _inputs = function(){
    inputLabels = document.getElementsByClassName('e-input-label');
    _getInputs(inputLabels);
  }

  var _textareas = function(){
    textareaLabels = document.getElementsByClassName('e-textarea-label');
    _getInputs(textareaLabels);
  }

  var _getInputs = function(labels){
    if (labels[0].classList[0] === 'e-input-label') {
    // console.log(labels[0].classList[0] === 'e-input-label');
    
      [].map.call(labels, function(label){
        label.getElementsByClassName('e-input')[0].addEventListener('focus', _onFocus);
        label.getElementsByClassName('e-input')[0].addEventListener('blur', _onBlur);
      });

    }else{
      [].map.call(labels, function(label){
        label.getElementsByClassName('e-textarea')[0].addEventListener('focus', _onFocus);
        label.getElementsByClassName('e-textarea')[0].addEventListener('blur', _onBlur);
      });
    }
  };

  var _onFocus = function(e) {
    this.parentNode.classList.add('visible');
    this.dataset.placeholder = this.getAttribute('placeholder'); 
    this.removeAttribute('placeholder');
  };

  var _onBlur = function(e){
    this.parentNode.classList.remove('visible')
    this.setAttribute('placeholder', this.dataset.placeholder);
  };

  return {
    inputs: _inputs,
    textareas: _textareas
  }
}();


if (document.getElementsByClassName('e-input-label').length) {
  animateInputLabel.inputs();
}

if (document.getElementsByClassName('e-textarea-label').length) {
  animateInputLabel.textareas();
}